module.exports = __webpack_public_path__ + "img/image12.34750f51.png";